module.exports = __webpack_public_path__ + "media/images/icons/dashboard-bf7ffb379e3ba69240ee44ff2fdfc897.svg";